import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getPenaltyCardColumns = () => [
  {
    key: "type",
    label: "Bezeichnung",
    minWidth: 160,
    maxWidth: 160,
    justifyContent: "start",
  },
  {
    key: "depreciation",
    label: "Abschreibung",
    minWidth: 120,
    maxWidth: 160,
    justifyContent: "end",
  },
  {
    key: "year",
    label: "Jahr",
    minWidth: 80,
    maxWidth: 80,
    justifyContent: "end",
  },
  {
    key: "quantity",
    label: "Betrag",
    minWidth: 80,
    maxWidth: 120,
    justifyContent: "end",
  },
];

export const getPenaltyCardData = ({ calculation }) => {
  const yearlyVectorCombinedLoan = calculation.yearlyVectorCombinedLoan;

  let totalPenaltyQuantity = 0;

  //TODO fix on BE side

  const penaltyCardData = yearlyVectorCombinedLoan
    .filter(
      (item) =>
        item.regularLoanPenaltyInterest > 0.001 ||
        item.specialLoanPenaltyInterest > 0.001
    )
    .map((item) => {
      totalPenaltyQuantity +=
        item.regularLoanPenaltyInterest + item.specialLoanPenaltyInterest;
      return {
        type: "Bereitstellungszinsen",
        depreciation: "Werbungskosten",
        year: item.year,
        quantity: convertValueToLocale(
          item.regularLoanPenaltyInterest + item.specialLoanPenaltyInterest,
          null,
          "€",
          null
        ),
      };
    });

  return [
    ...penaltyCardData,
    {
      type: "Summe",
      depreciation: null,
      year: null,
      quantity: convertValueToLocale(totalPenaltyQuantity, null, "€", null),
    },
  ];
};
